export default __webpack_public_path__ + "static/media/close-icon.316953b1.svg";